import React from "react";
import {
  Button,
  Icon,
  Input,
  Popup,
  WithPopup,
} from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../../utilities/Constants";
import { Translation } from "react-i18next";
import { ABB_CHECK_MARK, ABB_CLOSE } from "../../../utilities/IconConstants";
import Authorize from "../../../utilities/Authorize";

interface ISidebar {}
interface ISidebarProps {
  authKey?: string;
  // side bar collapse function
  onCollapseSidebar: () => void;
  // search value
  searchValue: string;
  // search functionality
  onSearch?: (e: any) => void;

  onCreateClick?: (e: any) => void;

  viewAll?: (e: any) => void;

  cloneClick?: (e: any) => void;
  showCloneIcon?: boolean;

  /*======================*/
  setName?: (val: string) => void;
  inputName?: any;
  onActivate?: () => void;
  isShowPopup?: boolean;
  onSave?: (e: any, val: boolean) => void;
  onDeactivate?: () => void;
  module?: string;
  setCode?: (val: string) => void;
  inputCode?: any;
  isShowCodeInput?: boolean;
  nameError?: boolean;
  codeError?: boolean;
  isButtonDisabled?: boolean;
  /*======================*/
}
export default class Sidebar extends React.Component<ISidebarProps, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    console.log(this.props.isShowPopup);

    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="sidebar">
              <div className="container px-3 mb-2">
                <ul className="row nav sidebar-icons px-0 mx-0">
                  <li className="nav-item justify-content-center icon-hover">
                    <button title={t("Collapse")}>
                      <Icon
                        name="abb/caret-left"
                        className="cursor-pointer"
                        sizeClass="large"
                        onClick={this.props.onCollapseSidebar}
                      />
                    </button>
                  </li>
                  <Authorize scopes={[`${this.props.authKey}:Add`]}>
                  <li className="nav-item justify-content-center icon-hover">
                    <button title={t("Create")}>
                      <Icon
                        name="abb/plus"
                        className="cursor-pointer"
                        sizeClass="medium"
                        onClick={this.props.onCreateClick}
                      />
                    </button>
                  </li></Authorize>
                  <Authorize scopes={[`${this.props.authKey}:Clone`]}>
                  <li
                    className={
                      this.props.showCloneIcon
                        ? "nav-item justify-content-center icon-hover"
                        : "d-none"
                    }
                  >
                    <button title={t("Clone")}>
                      <Icon
                        name="abb/copy"
                        className="cursor-pointer"
                        sizeClass="medium"
                        onClick={this.props.onActivate}
                      />
                    </button>
                  </li>
                  </Authorize>
                  <Authorize scopes={[`${this.props.authKey}:ViewAll`]}>
                  <li className="nav-item justify-content-center icon-hover">
                    <button title={t("View All")}>
                      <Icon
                        name="abb/list"
                        className="cursor-pointer"
                        sizeClass="medium"
                        onClick={this.props.viewAll}
                      />
                    </button>
                  </li>
                  </Authorize>
                </ul>

                <div className="text-center cursor my-1">
                  <WithPopup>
                    <div
                      className={
                        this.props.isShowPopup ? "ml-5 float-left" : null
                      }
                    ></div>
                    <Popup
                      className="popup-align-box"
                      trigger="controlled"
                      position="bottom center"
                      show={this.props.isShowPopup}
                      defaultOpen={false}
                      closeOnLostFocus={true}
                      onClose={() => this.props.onDeactivate()}
                    >
                      <p>
                        <Input
                          // tslint:disable-next-line: no-unused-expression
                          inputAttributes={{ autoFocus: "true" }}
                          onKeyUp={(e) => this.props.onSave(e, true)}
                          className={
                            this.props.nameError ? "error-code mt-2" : "mt-2"
                          }
                          dataType="text"
                          label={
                            t(this.props.module) + " " + t(CONSTANTS.LABLE_NAME)
                          }
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          maxLength={250}
                          value={String(this.props.inputName)}
                          onValueChange={(val: string) =>
                            this.props.setName(val)
                          }
                          showValidationBarWhenInvalid={this.props.nameError}
                          description={
                            this.props.nameError
                              ? this.props.inputName.length
                                ? t(CONSTANTS.INSTRUMENT_NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </p>
                      {(this.props.module !== CONSTANTS.MODULE_SAMPLE_NEW &&
                        this.props.module !== CONSTANTS.MODULE_TESTPLAN) ||
                      this.props.isShowCodeInput ? (
                        <p>
                          <Input
                            onKeyUp={(e) => this.props.onSave(e, true)}
                            className={
                              this.props.codeError ? "error-code mt-2" : "mt-2"
                            }
                            dataType="text"
                            label={t(CONSTANTS.LABEL_CODEID)}
                            placeholder={t(CONSTANTS.LABEL_CODEID)}
                            required={this.props?.module === CONSTANTS.MODULE_PROPERTY ? true : false}
                            maxLength={20}
                            value={String(this.props.inputCode)}
                            onValueChange={(val: string) =>
                              this.props.setCode(val)
                            }
                            showValidationBarWhenInvalid={this.props.codeError}
                            description={
                              this.props.codeError
                                ? this.props.inputCode.length
                                  ? t(
                                      CONSTANTS.INSTRUMENT_CODE_VALIDATION_ERROR
                                    )
                                  : t(CONSTANTS.FIELD_EMPTY_ERROR)
                                : ""
                            }
                          />
                        </p>
                      ) : null}

                      <div>
                        <Button
                          disabled={this.props.isButtonDisabled}
                          type="primary-blue"
                          shape="rounded"
                          text={t(CONSTANTS.BUTTON_CONFIRM)}
                          icon={ABB_CHECK_MARK}
                          className={
                            this.props.isButtonDisabled
                              ? "border"
                              : "border border-primary"
                          }
                          style={{ width: 110 }}
                          onClick={() => this.props.onSave(null, true)}
                        />
                        <Button
                          type="discreet-blue"
                          shape="rounded"
                          icon={ABB_CLOSE}
                          className="border border-primary mt-2"
                          onClick={this.props.onDeactivate}
                          style={{ marginLeft: 5 }}
                        />
                      </div>
                    </Popup>
                  </WithPopup>
                  <div className="clearfix" />
                </div>

                <div className="row px-0 mx-0 pr-3">
                  <div className="col-12 px-0 position-relative">
                    <Input
                      type="normal"
                      inputAttributes={{ autoFocus: "true" }}
                      dataType="text"
                      placeholder={t(CONSTANTS.LABEL_SEARCH)}
                      icon="abb/search"
                      value={this.props.searchValue}
                      onValueChange={this.props.onSearch}
                      className="ml-0"
                    />
                  </div>
                </div>
              </div>
              {this.props.children}
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
